import React from "react";
import PropTypes from "prop-types";
import MuiTextField from "@mui/material/TextField";

const TextField = ({
  label,
  innerRef,
  onChange,
  rows,
  minRows,
  maxRows,
  ...otherProps
}) => {
    const isMultiline = rows > 1 || minRows > 1 || maxRows > 1;
    return (
      <>
        {label}
        <div className="mgridform-value" style={{ flex: 1, width: isMultiline ? "100%" : undefined }}>
          <MuiTextField
            ref={innerRef}
            variant="standard"
            onChange={onChange ? (e) => onChange(e.target.value) : undefined}
            multiline={isMultiline}
            rows={rows}
            minRows={minRows}
            maxRows={maxRows}
            fullWidth
            {...otherProps}
          />
        </div>
      </>
    );
  };

TextField.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  innerRef: PropTypes.object,
  onChange: PropTypes.func,
  rows: PropTypes.number,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
};

export default TextField;